import React, { useEffect, useState } from 'react'
import Papa from 'papaparse'

const csvURL = 'https://anandstaticstagingcountrycoderequest.s3.ap-south-1.amazonaws.com/digiadglobal-anylatics/topic_insights.csv'

const TopicInsights = () => {
  const [data, setData] = useState([])

  useEffect(() => {
    fetch(csvURL)
      .then(res => res.text())
      .then(csvText => {
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            setData(results.data)
          }
        })
      })
  }, [])

  return (
    <div className="bg-white p-6 shadow rounded-xl">
      <h2 className="text-xl font-semibold mb-4">📊 Topic Insights</h2>
      {data.length > 0 ? (
        <div className="overflow-auto">
          <table className="min-w-full text-sm text-gray-700">
            <thead className="border-b font-medium">
              <tr>
                <th className="text-left p-2">Term</th>
                <th className="text-left p-2">Category</th>
                <th className="text-right p-2">Pageviews</th>
                <th className="text-right p-2">% Change</th>
                <th className="text-right p-2">Articles</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={idx} className="border-b hover:bg-gray-50">
                  <td className="p-2 text-left">{row['Term']}</td>
                  <td className="p-2 text-left">{row['Category']}</td>
                  <td className="p-2 text-right">{row['Pageviews']}</td>
                  <td
                    className={`p-2 text-right ${
                      row['% Change']?.includes('-') ? 'text-red-500' : 'text-green-600'
                    }`}
                  >
                    {row['% Change']}
                  </td>
                  <td className="p-2 text-right">{Number(row['Articles']).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-gray-500">Loading topic insights...</p>
      )}
    </div>
  )
}

export default TopicInsights
